import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {NotificationSubscription} from '../model/notification-subscription';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private readonly SERVER_URL = '/api/notifications';

  constructor(private http: HttpClient) { }

  listSubscriptions(): Observable<NotificationSubscription[]> {
    return this.http.get<NotificationSubscription[]>(`${this.SERVER_URL}`);
  }

  subscribe(type: string): Observable<void> {
    return this.http.post<void>(`${this.SERVER_URL}/${type}/subscribe`, {});
  }

  unsubscribe(type: string): Observable<void> {
    return this.http.post<void>(`${this.SERVER_URL}/${type}/unsubscribe`, {});
  }
}
